import React, { useEffect, useState } from "react";
import axios from "axios";

interface IProps {
  isLocation: any;
}

const GeoLocation: React.FC<IProps> = ({ isLocation }) => {
  const [locationName, setLocationName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isLocation?.locationData) {
      const [lat, lon] = isLocation.locationData.split(",");
      const fetchLocationName = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `https://nominatim.openstreetmap.org/reverse`,
            {
              params: {
                format: "json",
                lat,
                lon,
              },
            }
          );
          const data = response.data;
          setLocationName(data?.display_name || "Unknown location");
        } catch (error) {
          console.error("Error fetching location name:", error);
          setLocationName("Location not available");
        } finally {
          setLoading(false);
        }
      };
      fetchLocationName();
    }
  }, [isLocation?.locationData]);

  return (
    <div className="d-flex justify-content-center align-items-center mt-5 mb-4">
      <div
        className="card "
        style={{
          width: "100%",
          maxWidth: "700px",
          borderRadius: "6px",
          padding: "30px",
          backdropFilter: "blur(10px)",
          boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        }}
      >
        <div className="d-flex align-items-center">
          <div
            className="d-flex justify-content-center align-items-center me-4"

          >
            <i className="bi bi-geo-alt-fill text-primary fs-1"></i>
          </div>
          <div>
            <h5 className="mb-1 text-dark fw-bold">Your Current Location</h5>
            {loading ? (
              <div
                className="spinner-border text-primary spinner-border-sm mt-2"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <p
                className="mb-0 text-muted"
                style={{ fontSize: "15px", lineHeight: "1.4" }}
              >
                {locationName || "Location not available"}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoLocation;
